const RebetSvg = () => (
  <svg
    width="25"
    height="24"
    viewBox="0 0 25 24"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    pointerEvents="none"
  >
    <path
      d="M23.3604 9L21.3604 12.4641L17.8962 10.4641"
      stroke="currentColor"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M6.36035 13L2.89625 11L0.89625 14.4641"
      stroke="currentColor"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M21.4248 12C21.4248 7.02944 17.3954 3 12.4248 3C8.89111 3 5.83305 5.03656 4.36035 8"
      stroke="currentColor"
      strokeLinecap="round"
    />
    <path
      d="M3.29587 12C3.29587 16.9706 7.32531 21 12.2959 21C15.8296 21 18.8876 18.9634 20.3604 16"
      stroke="currentColor"
      strokeLinecap="round"
    />
  </svg>

);

export default RebetSvg;
